import { Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';
import { colorShade } from 'utils';

const template = styled.div`
  ${({ displayState, theme }) => css`
    display: flex;
    align-items: center;
    padding-left: 15px;
    padding-right: 15px;
    height: 40px;
    width: 50%;
    border: ${displayState?.isSelected ? `1px solid ${theme?.colour?.primary ?? "#1DBD6B"}` : displayState?.square ? '1px solid #E3E3E3' : ''};
    background: ${displayState?.isSelected ? colorShade(0.9, theme?.colour?.primary ?? '#1DBD6B') : '#FFFFFF'};

    ${displayState?.square && css`
      border-top: 0px;
      ${displayState?.isStartDate && css`
        border-left: 0px;
      `}
      ${!displayState?.isStartDate && css`
        border-right: 0px;
      `}
    `}

    @media screen and (min-width: 768px){
      border-radius: ${displayState?.isStartDate ? `200px 0px 0px 200px` : '0px 200px 200px 0px'};

      ${displayState?.square && css`
        border-radius: ${displayState?.isStartDate ? `8px 0px 0px 0px` : '0px 8px 0px 0px'};
      `}
    }
  `}
`;

export default Wrapper(template);